import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientMetadataComponent } from '@brightai/ui';
import { BrightaiLayoutService } from '../brightai-layout.service';

@Component({
  selector: 'bai-brightai-layout',
  imports: [CommonModule, ClientMetadataComponent],
  templateUrl: './brightai-layout.component.html',
  styleUrl: './brightai-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrightaiLayoutComponent {
  layoutService = inject(BrightaiLayoutService);

  collapsed = computed(()=> this.layoutService.collapsed());

  toggleSidebar() {
    this.layoutService.toggleCollapsed();
  }
}
